/* Ninja kiwi variant — headband + slit eyes. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderNinja(p: KiwiPalette) {
  return (
    <>
      {/* Body */}
      <path d="M12 6H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V6Z" fill={p.body} />
      {/* Headband */}
      <rect x="6" y="8" width="20" height="2" fill={p.accent} opacity={0.5} />
      {/* Headband tail */}
      <path d="M24 6H26V8H24V6ZM26 4H28V6H26V4ZM28 2H30V4H28V2Z" fill={p.accent} opacity={0.5} />
      {/* Beak — sharp */}
      <path d="M4 12H6V14H4V12ZM2 14H4V16H2V14ZM0 14H2V16H0V14Z" fill={p.beak} />
      {/* Tuft feathers */}
      <path d="M10 4H12V6H10V4ZM8 2H10V4H8V2ZM12 2H14V4H12V2Z" fill={p.body} />
      {/* Eye — narrow slit */}
      <rect x="10" y="11" width="6" height="4" fill={p.eyeBg} />
      <rect x="10" y="12" width="4" height="2" fill={p.pupil} />
      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
